"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PtoApprovalsCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const UserContext_1 = require("../contexts/UserContext");
const react_native_1 = require("react-native");
const cancelable_promise_1 = require("cancelable-promise");
const Card_1 = __importDefault(require("../components/Card"));
const CardTitle_1 = __importDefault(require("../components/CardTitle"));
const List_1 = __importDefault(require("../components/List"));
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const Loading_1 = __importDefault(require("../components/Loading"));
const react_i18next_1 = require("react-i18next");
const TimeAttendance_1 = __importDefault(require("../api/TimeAttendance"));
const Button_1 = __importDefault(require("../components/Button"));
const PtoApproval_1 = __importDefault(require("../partials/PtoApproval"));
const PlatformModal_1 = __importDefault(require("../components/PlatformModal"));
const PtoBalances_1 = __importDefault(require("../partials/PtoBalances"));
const PtoScheduled_1 = __importDefault(require("../partials/PtoScheduled"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
function PtoApprovalsCard(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const promise = react_1.default.useRef(null);
    const [modal, setModal] = react_1.default.useState({ open: false, type: "", request: null });
    const [status, setStatus] = react_1.default.useState(null);
    const [ptoRequests, setPtoRequests] = react_1.default.useState(null);
    const refresh = react_1.default.useCallback(async () => {
        promise.current?.cancel();
        setStatus('loading');
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => TimeAttendance_1.default.getPTORequests(token, 4)))
            .then((data) => {
            setPtoRequests(data);
            setStatus('done');
        })
            .catch((e) => {
            setPtoRequests(null);
            setStatus(e == 404 ? 'done' : 'error');
        });
    }, []);
    react_1.default.useEffect(() => {
        refresh();
        return () => {
            promise.current?.cancel();
        };
    }, []);
    const onAction = (action, ptoRequest) => {
        props.navigation.navigate('PtoApprovalAction', {
            action: action,
            name: ptoRequest.name,
            employeeId: ptoRequest.employeeId,
            leaveRequest: ptoRequest.leaveRequest,
            checksum: ptoRequest.checksum,
            startDate: ptoRequest.startDate,
            endDate: ptoRequest.endDate,
            leaveHours: ptoRequest.totalHours
        });
        react_native_1.DeviceEventEmitter.addListener("event.ptoApprovalAction", () => refresh());
    };
    const onViewBalances = react_1.default.useCallback((ptoRequest) => {
        setModal({ open: true, type: "balance", request: ptoRequest });
    }, []);
    const onViewPending = react_1.default.useCallback((ptoRequest) => {
        setModal({ open: true, type: "pending", request: ptoRequest });
    }, []);
    const onViewApproved = react_1.default.useCallback((ptoRequest) => {
        setModal({ open: true, type: "approved", request: ptoRequest });
    }, []);
    return ((0, jsx_runtime_1.jsxs)(Card_1.default, { children: [(0, jsx_runtime_1.jsx)(CardTitle_1.default, { title: t('time:text.ptoApprovals'), style: { marginBottom: 8 }, children: (0, jsx_runtime_1.jsxs)(Button_1.default, { type: "outline", accessibilityHint: t('time:text.ptoApprovals'), onPress: () => props.navigation.navigate('PtoApprovals'), children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Primary, fontSize: 14, fontWeight: '500', marginHorizontal: 6 }, children: t('common:text.viewAll') }), (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: THEME.Primary, icon: Theme_1.ICONS.Regular.ChevronRight, size: 14, style: { marginRight: 6 } })] }) }), (status == 'done' && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(FadeInView_1.default, { style: { marginHorizontal: 0, marginBottom: -4 }, children: (0, jsx_runtime_1.jsx)(List_1.default, { style: { marginBottom: 8 }, data: ptoRequests, renderItem: (item, index) => ((0, jsx_runtime_1.jsx)(PtoApproval_1.default, { request: item, onApprove: (ptoRequest) => onAction("approve", ptoRequest), onDeny: (ptoRequest) => onAction("deny", ptoRequest), onViewBalances: (ptoRequest) => onViewBalances(ptoRequest), onViewPending: (ptoRequest) => onViewPending(ptoRequest), onViewApproved: (ptoRequest) => onViewApproved(ptoRequest) })), keyExtractor: (item, index) => item.leaveRequest, itemSeparator: () => (0, jsx_runtime_1.jsx)(react_native_1.View, { style: [STYLES.separator, { marginVertical: 4 }] }), listEmpty: () => (0, jsx_runtime_1.jsx)(EmptyRequests, {}) }) }) }))) || (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status == 'loading', error: status == 'error', onRetry: () => refresh() }), modal.open &&
                (0, jsx_runtime_1.jsxs)(PlatformModal_1.default, { isVisible: modal.open, onDismiss: () => setModal({ open: false, type: "", request: null }), children: [modal.type == "balance" &&
                            (0, jsx_runtime_1.jsx)(PtoBalances_1.default, { balance: modal.request, onDismiss: () => setModal({ open: false, type: "", request: null }) }), modal.type == "pending" &&
                            (0, jsx_runtime_1.jsx)(PtoScheduled_1.default, { type: "pending", request: modal.request, onDismiss: () => setModal({ open: false, type: "", request: null }) }), modal.type == "approved" &&
                            (0, jsx_runtime_1.jsx)(PtoScheduled_1.default, { type: "approved", request: modal.request, onDismiss: () => setModal({ open: false, type: "", request: null }) })] })] }));
}
const EmptyRequests = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { alignItems: "center", justifyContent: "center", marginVertical: 8 }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.CalendarCircleUser, size: 48, color: THEME.ImageNull, style: { marginBottom: 6 } }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { textAlign: 'center', fontSize: (size != 'sm' ? 16 : 14), color: THEME.TextNull }, children: t('time:text.noPTOReqs') })] }));
};
